export const ellipsisName = (name?: string | null, fallBackName?: string, max = 10) => {
  if (!name) {
    return fallBackName ?? '';
  }

  if (name.length > max + 1) {
    return name.slice(0, max).concat('...');
  }

  return name;
};
